import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Modal } from 'react-bootstrap-5';
import { faFileExport } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { post } from 'helpers/api';

export default function PropertyOwnerExport({ exportPath, show, onHide }) {
  const [loading, setLoading] = useState(false);
  const [exportComplete, setExportComplete] = useState(false);
  const [exportName, setExportName] = useState('');

  const handleExport = () => {
    setLoading(true);
    post(exportPath, { name: exportName, type: 'property' }).then(() => {
      setLoading(false);
      setExportComplete(true);
    });
  };

  if (!show) return null;

  return (
    <React.Fragment>
      <Modal.Body>
        {exportComplete ? (
          <div>
            Property / Owner export queued!&nbsp;
            Check your inbox or navigate to your <a href="/connect/profile#exports">Profile Settings</a>&nbsp;
            to download your export
          </div>
        ) : (
          <React.Fragment>
            <Form.Group className="mb-2">
              <Form.Label>Name</Form.Label>
              <Form.Control
                placeholder="Export Name"
                value={exportName}
                onChange={e => setExportName(e.target.value)}
              />
            </Form.Group>
          </React.Fragment>
        )}
      </Modal.Body>
      <Modal.Footer>
        {exportComplete ? (
          <Button variant="success" onClick={onHide}>
            Done!
          </Button>
        ) : (
          <React.Fragment>
            <Button disabled={loading} variant="link" onClick={onHide}>
              Cancel
            </Button>
            <Button disabled={loading} variant="secondary" onClick={handleExport}>
              <FontAwesomeIcon icon={faFileExport}/>
              Export Property / Owner Data
            </Button>
          </React.Fragment>
        )}
      </Modal.Footer>
    </React.Fragment>
  );
}

PropertyOwnerExport.propTypes = {
  exportPath: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired
};
